/* global chrome */
// The Playground (playground.comprehendpt.ai) signs the extension in on the
// user's behalf: its install mini-player sends SET_SESSION to background.js,
// which stages the credentials in chrome.storage.local and boots the app once
// in a hidden tab (?adoptPlaygroundSession=1). Adopting them is exactly what
// Login does after a successful sign-in, so the side panel comes up signed in
// the next time it opens. No-op outside the extension.
import { storeLocalData } from './Common.js';

export const PLAYGROUND_SESSION_KEY = 'comprehendpt_playground_session';

function extensionLocalStorage() {
  if (typeof chrome !== 'undefined' && chrome.runtime?.id && chrome.storage?.local) {
    return chrome.storage.local;
  }
  return null;
}

export async function adoptPlaygroundSession() {
  const storage = extensionLocalStorage();
  if (!storage) return false;
  const result = await new Promise((resolve) => {
    try {
      storage.get([PLAYGROUND_SESSION_KEY], (r) => resolve(r || {}));
    } catch (e) {
      resolve({});
    }
  });
  const pending = result[PLAYGROUND_SESSION_KEY];
  if (!pending) return false;
  const sessionKey = Number(pending.sessionKey);
  const sessionEmail = String(pending.sessionEmail || '').trim();
  let adopted = false;
  if (Number.isInteger(sessionKey) && sessionKey > 0 && sessionEmail) {
    // Sessions are not environment-bound (dev and prod share the app_session
    // table), so a key minted by the dev playground is adopted as-is — no
    // backend switch. background.js already checked it with the API.
    storeLocalData(String(sessionKey));
    storeLocalData(sessionEmail, true);
    try {
      sessionStorage.setItem('sessionKey', String(sessionKey));
      sessionStorage.setItem('sessionEmail', sessionEmail);
    } catch (e) {
      /* storage blocked */
    }
    adopted = true;
  }
  try {
    storage.remove(PLAYGROUND_SESSION_KEY);
  } catch (e) {
    /* ok */
  }
  return adopted;
}
